<script>
import axios from 'axios';
import moment from 'moment';

export default {
    props: {
        record: {
            required: true,
            type: Object
        }
    },

    data() {
        return {
            showLogs: false,
            importLogs: []
        }
    },
    computed: {
        statusName() {
            if(!this.record.status) {
                return null;
            }

            return this.record.status.charAt(0).toUpperCase() + this.record.status.slice(1);
        },

        lastUpdated() {
            if(!this.record.updated_at) {
                return null;
            }

            return moment(this.record.updated_at).format('MM/DD/YYYY h:mm A');
        }
    },

    methods: {
        async toggleLogDetails() {
            this.showLogs = !this.showLogs;
        },

        async downloadFile(){
            await axios.get('/api/files/' + this.record.output.file_id + '/download').then(response => {
                let signedFileUrl = response.data.meta?.url;
                if(! signedFileUrl) {
                    window.notify.error("Cannot download the file", "Invalid file information");
                    return;
                }

                 window.open(signedFileUrl);

            }).catch(error => {
                window.notify.apiError(error);
            });
        },
    }
}
</script>
<template>
    <div class="m-3 shadow p-4">
        <div class="flex w-full items-center">
            <div class="w-1/2 text-center">
                <div class="mb-2 flex justify-between">
                    <div class="text-bold">Operation Id:</div>
                    <div class="w-1/2 break-words">
                        {{ record.input?.sharedOperationID }}
                    </div>
                </div>
                <div class="flex justify-between">
                    <div class="text-bold">Import generated by:</div>
                    <div class="w-1/2 break-words">
                        {{ record.user_full_name }}
                    </div>
                </div>
            </div>
            <div class="w-1/4">
                <div class="mb-2 flex justify-between">
                    <div class="text-bold">Status:</div>
                    <div class="flex items-center justify-center">
                        <span class="mr-2">{{ statusName }}</span>
                        <div v-if="record.status === 'finished'" class="led-box">
                            <div class="led-green"></div>
                        </div>
                        <div v-else-if="record.status === 'failed'" class="led-box">
                            <div class="led-red"></div>
                        </div>
                        <div v-else-if="record.status === 'queued'" class="led-box">
                            <div class="led-yellow"></div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-between">
                    <div class="text-bold">Import Last Updated:</div>
                    <div>{{ lastUpdated }}</div>
                </div>
            </div>
            <div class="w-1/5 ml-4">
                <button class="inputbutton1" @click="toggleLogDetails">
                    <span v-if="!showLogs">
                        Show Details
                    </span>
                    <span v-else>
                        Hide Details
                    </span>
                    
                </button>
            </div>
        </div>
        <div v-show="showLogs" class="mx-2 border-t p-2">
            <div v-if="this.record.output?.file_id">
                
                <div class="flex justify-left py-2">
                    <button class="inputbutton1" @click="downloadFile">
                        <font-awesome-icon
                            icon="download"
                            class="mr-3 cursor-pointer"
                        >
                        </font-awesome-icon>
                        Download Import File
                    </button>
                </div>
            </div>
            <h4 class="my-2">Bulk Import Logs:</h4>

            <div class="flex items-center">
                <div class="w-full px-1">
                    <div v-if="typeof record.output?.messages === 'object'">
                        <project-bulk-import-result-log-message 
                            :messages="record.output.messages">
                        </project-bulk-import-result-log-message>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
